/* MoonBites "Feeling Lucky? Match 3" popup — vanilla JS, no dependencies.
   Game → prize → sleep question → email → code. The prize
   tier is a real draw (lucky_chance % win the lucky code), made once per
   browser and stored, so replays can't re-roll it. */
(function () {
  'use strict';

  var root = document.getElementById('mbq-root');
  if (!root) return;

  // Never on cart/checkout/account pages.
  var SUPPRESSED_PATHS = ['/cart', '/checkout', '/pages/account', '/account'];
  var path = window.location.pathname;
  for (var i = 0; i < SUPPRESSED_PATHS.length; i++) {
    if (path.indexOf(SUPPRESSED_PATHS[i]) !== -1) return;
  }

  var CONVERTED_KEY = 'mbq_converted';
  var LAST_SHOWN_KEY = 'mbq_last_shown';
  var PRIZE_KEY = 'mbq_prize';
  var SNOOZE_KEY = 'mbq_snooze_until';          // localStorage: no auto-open before this time
  var AUTO_COUNT_KEY = 'mbq_auto_count';        // sessionStorage: auto-opens this visit
  var DISMISSED_KEY = 'mbq_dismissed_at';       // sessionStorage: last auto-open dismissal
  var CARTED_KEY = 'mbq_carted';                // sessionStorage: added to bag this visit

  function safeGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, val) {
    try { window.localStorage.setItem(key, val); } catch (e) { /* storage unavailable, fail silently */ }
  }
  function sGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function sSet(key, val) {
    try { window.sessionStorage.setItem(key, val); } catch (e) { /* no-op */ }
  }

  // ── Prize draw ──
  var STD = { pct: root.getAttribute('data-discount-pct') || '20', code: root.getAttribute('data-discount-code') || 'WELCOME20', lucky: false };
  var LUCKY = root.getAttribute('data-lucky-code')
    ? { pct: root.getAttribute('data-lucky-pct') || '45', code: root.getAttribute('data-lucky-code'), lucky: true }
    : null;
  var LUCKY_CHANCE = parseFloat(root.getAttribute('data-lucky-chance')) || 0;

  function getPrize() {
    var stored = null;
    try { stored = JSON.parse(safeGet(PRIZE_KEY) || 'null'); } catch (e) { stored = null; }
    if (stored && stored.code === STD.code) return STD;
    if (stored && LUCKY && stored.code === LUCKY.code) return LUCKY;
    var won = LUCKY && Math.random() * 100 < LUCKY_CHANCE ? LUCKY : STD;
    safeSet(PRIZE_KEY, JSON.stringify({ code: won.code, at: Date.now() }));
    return won;
  }

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var overlay = document.getElementById('mbqOverlay');
  var card = document.getElementById('mbqCard');
  var closeBtn = document.getElementById('mbqClose');
  var skipBtn = document.getElementById('mbqSkip1');
  var grid = document.getElementById('mbqGrid');
  var launcher = document.getElementById('mbqLauncher');
  var tiles = root.querySelectorAll('[data-tile]');
  var burst = document.getElementById('mbqBurst');
  var liveEl = document.getElementById('mbqLive');
  var swaps = {
    gameTitle: document.getElementById('mbqGameTitle'), winTitle: document.getElementById('mbqWinTitle'),
    gameSub: document.getElementById('mbqGameSub'), winSub: document.getElementById('mbqWinSub')
  };
  var backBtn = document.getElementById('mbqBack');
  var options = root.querySelectorAll('.mbq-option');
  var form = document.getElementById('mbqForm');
  var emailInput = document.getElementById('mbqEmail');
  var errorEl = document.getElementById('mbqError');
  var submitBtn = document.getElementById('mbqSubmit');
  var copyBtn = document.getElementById('mbqCopy');
  var codeEl = document.getElementById('mbqCode');
  var shopCta = document.getElementById('mbqShopCta');
  var consentInput = document.getElementById('mbqConsent');
  var steps = root.querySelectorAll('.mbq-step');

  var prize = STD;
  var currentSegment = null;
  var lastFocusedEl = null;
  var isOpen = false;
  var triggersActive = false;

  // ── Klaviyo integration (public API key — safe for client-side use) ──
  var KLAVIYO_COMPANY_ID = 'UpsrMi';
  var KLAVIYO_LIST_ID = 'VSdhGU';

  function klaviyoSubscribe(email, segment) {
    var discountPct = prize.pct;
    var discountCode = prize.code;
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'revision': '2024-10-15' };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
        }
      })
    }).catch(function () { /* fail silently — event call below still fires */ });

    fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: {
              source: 'quiz-popup',
              game: 'match3',
              segment: segment || '',
              discount_pct: discountPct,
              discount_code: discountCode,
              lucky: prize.lucky
            },
            metric: { data: { type: 'metric', attributes: { name: 'Signed Up' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      })
    }).catch(function () { /* fail silently */ });
  }

  // ── Analytics helpers ──
  function pushEvent(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data || {}));
    } catch (e) { /* no-op */ }
    try {
      if (typeof window.fbq === 'function') {
        if (name === 'Lead') window.fbq('track', 'Lead', data || {});
        else window.fbq('trackCustom', name, data || {});
      }
    } catch (e) { /* no-op */ }
  }

  // ── Step navigation ──
  function showStep(name) {
    steps.forEach(function (step) {
      var active = step.getAttribute('data-step') === name;
      step.classList.toggle('is-active', active);
    });
    var active = root.querySelector('.mbq-step[data-step="' + name + '"]');
    if (name === 'email' && emailInput) {
      setTimeout(function () { emailInput.focus(); }, prefersReducedMotion ? 0 : 250);
    } else if (active && isOpen) {
      var first = active.querySelector('.mbq-option, .mbq-copy, [data-tile]');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, prefersReducedMotion ? 0 : 250);
    }
    if (card) card.scrollTop = 0;
  }

  // ── Focus trap ──
  function getFocusable() {
    return card.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }
  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var focusable = getFocusable();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { closePopup(); return; }
    trapFocus(e);
  }

  // ── Open / close ──
  // ── "Mystery Discount" launcher: appears once the popup has been seen
  // (dismissed or completed) and re-opens the game on any page. ──
  function setLauncher(show) {
    if (!launcher) return;
    if (show) {
      launcher.hidden = false;
      void launcher.offsetWidth;
      launcher.classList.add('is-visible');
    } else {
      launcher.classList.remove('is-visible');
      launcher.hidden = true;
    }
  }

  function openPopup() {
    if (isOpen) return;
    isOpen = true;
    setLauncher(false);
    safeSet(LAST_SHOWN_KEY, String(Date.now()));
    lastFocusedEl = document.activeElement;
    overlay.hidden = false;
    // Force reflow so the opacity/transform transition actually runs.
    void overlay.offsetHeight;
    overlay.setAttribute('data-open', 'true');
    document.addEventListener('keydown', onKeydown);
    document.body.style.overflow = 'hidden';
    setTimeout(function () { (tiles[0] || closeBtn).focus({ preventScroll: true }); }, prefersReducedMotion ? 0 : 350);
    pushEvent('QuizStarted', { game: 'match3' });
  }

  function closePopup() {
    if (!isOpen) return;
    isOpen = false;
    overlay.setAttribute('data-open', 'false');
    document.removeEventListener('keydown', onKeydown);
    document.body.style.overflow = '';
    setTimeout(function () {
      overlay.hidden = true;
      setLauncher(true);
      var back = lastFocusedEl && lastFocusedEl !== launcher ? lastFocusedEl : launcher;
      if (back && typeof back.focus === 'function') back.focus({ preventScroll: true });
    }, prefersReducedMotion ? 0 : 350);
  }

  // ── Match 3 game ──
  // The player picks exactly 3 of the 9 cards; all three reveal the prize
  // they drew (9 in 10: three standard cards, 1 in 10: three lucky cards).
  var flipped = 0;
  var matched = 0;
  var won = false;
  var WIN_AT = 3;
  var faceScript = [];

  function faceHTML(p) {
    return '<span class="mbq-face-line"><strong>' + p.pct + '%</strong><small>OFF</small></span>' + (p.lucky ? '<i class="mbq-face-star" aria-hidden="true">✦</i>' : '');
  }

  function applyPrize(p) {
    root.querySelectorAll('[data-mbq-pct]').forEach(function (el) { el.textContent = p.pct; });
    if (codeEl) codeEl.textContent = p.code;
    if (shopCta) {
      var redirect = root.getAttribute('data-redirect') || '/products/moonbites-sleep-gummies';
      shopCta.setAttribute('href', '/discount/' + encodeURIComponent(p.code) + '?redirect=' + encodeURIComponent(redirect));
    }
    swaps.winTitle.textContent = p.lucky ? 'Jackpot. You matched 3.' : 'You matched 3.';
    card.classList.toggle('is-lucky', !!p.lucky);
  }

  function resetGame() {
    flipped = 0;
    matched = 0;
    won = false;
    faceScript = [prize, prize, prize];
    grid.classList.remove('is-won', 'is-gathered');
    if (burst) { burst.classList.remove('is-on'); burst.innerHTML = ''; }
    tiles.forEach(function (tile, i) {
      tile.classList.remove('is-flipped', 'is-match', 'is-lucky');
      tile.style.removeProperty('--dx'); tile.style.removeProperty('--dy'); tile.style.removeProperty('--rot'); tile.style.zIndex = '';
      tile.removeAttribute('aria-disabled');
      tile.setAttribute('aria-label', 'Card ' + (i + 1) + ', face down');
    });
    setSwap(false);
    if (liveEl) liveEl.textContent = '';
    if (termsMore) { termsMore.hidden = true; if (termsToggle) termsToggle.setAttribute('aria-expanded', 'false'); }
  }

  function setSwap(isWin) {
    swaps.gameTitle.classList.toggle('is-shown', !isWin);
    swaps.winTitle.classList.toggle('is-shown', isWin);
    swaps.gameSub.classList.toggle('is-shown', !isWin);
    swaps.winSub.classList.toggle('is-shown', isWin);
    swaps.gameTitle.setAttribute('aria-hidden', isWin ? 'true' : 'false');
    swaps.winTitle.setAttribute('aria-hidden', isWin ? 'false' : 'true');
    swaps.gameSub.setAttribute('aria-hidden', isWin ? 'true' : 'false');
    swaps.winSub.setAttribute('aria-hidden', isWin ? 'false' : 'true');
  }

  function flipTile(tile) {
    if (won || tile.classList.contains('is-flipped')) return;
    var face = faceScript[flipped] || prize;
    flipped++;
    tile.querySelector('.mbq-tile__face').innerHTML = faceHTML(face);
    tile.classList.toggle('is-lucky', !!face.lucky);
    tile.classList.add('is-flipped');
    tile.setAttribute('aria-disabled', 'true');
    tile.setAttribute('aria-label', face.pct + '% off');
    if (face === prize) { matched++; tile.classList.add('is-match'); }
    if (matched < WIN_AT) {
      if (liveEl) liveEl.textContent = face.pct + '% off. ' + matched + ' of ' + WIN_AT + ' picked.';
      return;
    }
    won = true;
    tiles.forEach(function (t) { if (!t.classList.contains('is-flipped')) t.setAttribute('aria-disabled', 'true'); });
    pushEvent('GameWon', { game: 'match3', discount_pct: prize.pct, lucky: prize.lucky });
    if (liveEl) liveEl.textContent = 'You matched 3. ' + prize.pct + '% off is yours.';

    if (prefersReducedMotion) {
      grid.classList.add('is-won');
      setSwap(true);
      setTimeout(finishGame, 1400);
      return;
    }
    // Let the 3rd card finish flipping, then gather the three into the middle
    // of the board as a small fan, then burst stars out from behind them.
    setTimeout(gatherMatches, 650);
    setTimeout(function () { setSwap(true); }, 900);
    setTimeout(starBurst, 1150);
    setTimeout(finishGame, 3100);
  }

  function finishGame() {
    // Someone who already signed up (replaying from the launcher) goes straight to their code.
    if (isOpen) showStep(safeGet(CONVERTED_KEY) ? 'reveal' : 'quiz');
  }

  function gatherMatches() {
    var g = grid.getBoundingClientRect();
    var cx = g.left + g.width / 2;
    var cy = g.top + g.height / 2;
    var fan = [{ x: -26, r: -10 }, { x: 0, r: 0 }, { x: 26, r: 10 }];
    var picks = Array.prototype.filter.call(tiles, function (t) { return t.classList.contains('is-match'); });
    picks.sort(function (a, b) { return a.getBoundingClientRect().left - b.getBoundingClientRect().left; });
    picks.forEach(function (tile, k) {
      var r = tile.getBoundingClientRect();
      var f = fan[k] || fan[1];
      tile.style.setProperty('--dx', Math.round(cx - (r.left + r.width / 2) + f.x) + 'px');
      tile.style.setProperty('--dy', Math.round(cy - (r.top + r.height / 2) + (k === 1 ? -6 : 4)) + 'px');
      tile.style.setProperty('--rot', f.r + 'deg');
      tile.style.zIndex = k === 1 ? 4 : 3;
    });
    grid.classList.add('is-won', 'is-gathered');
  }

  function starBurst() {
    if (!burst) return;
    var g = grid.getBoundingClientRect();
    var c = card.getBoundingClientRect();
    burst.style.left = Math.round(g.left - c.left + g.width / 2) + 'px';
    burst.style.top = Math.round(g.top - c.top + card.scrollTop + g.height / 2) + 'px';
    burst.innerHTML = '';
    var COUNT = 22;
    for (var i = 0; i < COUNT; i++) {
      var s = document.createElement('i');
      var angle = (i / COUNT) * Math.PI * 2 + (Math.random() - 0.5) * 0.5;
      var dist = 90 + Math.random() * 90;
      var size = 8 + Math.random() * 12;
      s.className = 'mbq-star' + (i % 4 === 0 ? ' mbq-star--white' : '') + (i % 5 === 0 ? ' mbq-star--dot' : '');
      s.style.setProperty('--x', Math.round(Math.cos(angle) * dist) + 'px');
      s.style.setProperty('--y', Math.round(Math.sin(angle) * dist) + 'px');
      s.style.setProperty('--s', size.toFixed(1) + 'px');
      s.style.setProperty('--spin', Math.round((Math.random() - 0.5) * 240) + 'deg');
      s.style.animationDelay = Math.round(Math.random() * 120) + 'ms';
      burst.appendChild(s);
    }
    burst.classList.remove('is-on');
    void burst.offsetWidth;
    burst.classList.add('is-on');
  }

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function () { flipTile(tile); });
  });

  // Every open starts at the game. The code only appears after the game, the
  // sleep question AND an email submit (or for someone already signed up).
  function openPopupSmart() {
    prize = getPrize();
    applyPrize(prize);
    resetGame();
    root.querySelectorAll('.mbq-option.is-selected').forEach(function (o) { o.classList.remove('is-selected'); });
    showStep('game');
    openPopup();
  }

  closeBtn.addEventListener('click', function () { closePopup(); });
  var termsToggle = document.getElementById('mbqTermsToggle');
  var termsMore = document.getElementById('mbqTermsMore');
  if (termsToggle && termsMore) {
    termsToggle.addEventListener('click', function () {
      var open = termsMore.hidden;
      termsMore.hidden = !open;
      termsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  applyPrize(prize);
  if (launcher) {
    launcher.addEventListener('click', function () {
      pushEvent('MysteryDiscountReopened', { game: 'match3' });
      openPopupSmart();
    });
    if (safeGet(LAST_SHOWN_KEY) || safeGet(CONVERTED_KEY)) setLauncher(true);
  }
  skipBtn.addEventListener('click', function () { closePopup(); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
  backBtn.addEventListener('click', function () { showStep('quiz'); });

  // ── Sleep question ──
  options.forEach(function (btn) {
    btn.addEventListener('click', function () {
      currentSegment = btn.getAttribute('data-segment');
      options.forEach(function (o) { o.classList.toggle('is-selected', o === btn); });
      pushEvent('QuizAnswered', { segment: currentSegment });
      setTimeout(function () { showStep('email'); }, prefersReducedMotion ? 0 : 220);
    });
  });

  // ── Step 2: email validation + submit ──
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setError(msg) {
    if (msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
      emailInput.classList.add('is-invalid');
    } else {
      errorEl.hidden = true;
      emailInput.classList.remove('is-invalid');
    }
  }

  function setLoading(loading) {
    submitBtn.disabled = loading;
    submitBtn.setAttribute('data-loading', loading ? 'true' : 'false');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = emailInput.value.trim();

    if (!EMAIL_RE.test(email)) {
      setError('Please enter a valid email address.');
      emailInput.focus();
      return;
    }
    if (consentInput && !consentInput.checked && consentInput.hasAttribute('required')) {
      setError('Please confirm you’d like to receive emails.');
      return;
    }
    setError(null);
    setLoading(true);

    klaviyoSubscribe(email, currentSegment);
    safeSet(CONVERTED_KEY, String(Date.now()));
    pushEvent('Lead', { segment: currentSegment });
    setLoading(false);
    showStep('reveal');
  });

  // ── Step 3: copy code ──
  copyBtn.addEventListener('click', function () {
    var code = codeEl.textContent.trim();
    function markCopied() {
      copyBtn.setAttribute('data-copied', 'true');
      setTimeout(function () { copyBtn.removeAttribute('data-copied'); }, 2200);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(markCopied).catch(function () { fallbackCopy(code, markCopied); });
    } else {
      fallbackCopy(code, markCopied);
    }
  });

  function fallbackCopy(text, done) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) { /* no-op */ }
    document.body.removeChild(ta);
    done();
  }

  // ── Triggers (common DTC pattern) ──
  // 1st auto-open: after `data-delay` seconds OR `data-scroll`% scroll depth OR
  //    desktop exit intent, whichever comes first.
  // 2nd auto-open: one reminder, REMIND_MS after they closed the first, only if
  //    they're still actively scrolling and haven't added anything to the bag.
  // Then no more auto-opens this visit; the Mystery Discount launcher stays.
  // After two dismissals, auto-open is snoozed for SNOOZE_MS across visits.
  // Never for anyone who has signed up, never on cart/checkout.
  var REMIND_MS = 3 * 60 * 1000;
  var ACTIVE_WINDOW_MS = 20 * 1000;
  var SNOOZE_MS = 3 * 24 * 60 * 60 * 1000;
  var MAX_AUTO = 1;  // one auto-open per session; once closed it stays closed this visit
  var lastActivity = 0;
  var autoOpenedThisPage = false;

  function autoCount() { return parseInt(sGet(AUTO_COUNT_KEY), 10) || 0; }

  function canAutoOpen() {
    if (isOpen || safeGet(CONVERTED_KEY)) return false;
    if (sGet(DISMISSED_KEY)) return false;
    // Never over the open cart drawer.
    if (document.documentElement.classList.contains('mbd-locked')) return false;
    if (autoCount() >= MAX_AUTO) return false;
    var snooze = parseInt(safeGet(SNOOZE_KEY), 10);
    if (!isNaN(snooze) && Date.now() < snooze) return false;
    return true;
  }

  function autoOpen(reason) {
    if (!canAutoOpen()) return;
    autoOpenedThisPage = true;
    sSet(AUTO_COUNT_KEY, String(autoCount() + 1));
    pushEvent('PopupAutoOpened', { game: 'match3', reason: reason, count: autoCount() });
    openPopupSmart();
  }

  // Remember auto-open dismissals so the reminder / snooze logic can use them.
  var baseClose = closePopup;
  closePopup = function () {
    var wasOpen = isOpen;
    baseClose();
    if (!wasOpen || safeGet(CONVERTED_KEY)) return;
    sSet(DISMISSED_KEY, String(Date.now()));
    if (autoCount() >= MAX_AUTO) safeSet(SNOOZE_KEY, String(Date.now() + SNOOZE_MS));
  };

  function markCarted() { sSet(CARTED_KEY, '1'); }

  function setupTriggers() {
    if (triggersActive) return;
    triggersActive = true;

    var delayMs = (parseFloat(root.getAttribute('data-delay')) || 25) * 1000;
    var scrollPct = parseFloat(root.getAttribute('data-scroll'));
    if (isNaN(scrollPct)) scrollPct = 50;
    var exitIntent = root.getAttribute('data-exit-intent') === 'true';

    // First show: never before `delayMs` on the page, so shoppers see the
    // product first. Exit intent / scroll depth only count after that point.
    var pageStart = Date.now();
    function pastDelay() { return Date.now() - pageStart >= delayMs; }
    if (autoCount() === 0) {
      setTimeout(function () { if (autoCount() === 0) autoOpen('delay'); }, delayMs);
      if (exitIntent && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
        document.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY <= 0 && autoCount() === 0 && pastDelay()) autoOpen('exit-intent');
        });
      }
    }

    window.addEventListener('scroll', function () {
      lastActivity = Date.now();
      // Owner rule: never before 25 s on the page, scrolling doesn't bring it forward.
      if (autoCount() === 0 && scrollPct > 0 && pastDelay()) {
        var doc = document.documentElement;
        var depth = (window.scrollY + window.innerHeight) / Math.max(doc.scrollHeight, 1) * 100;
        if (depth >= scrollPct) autoOpen('scroll');
      }
    }, { passive: true });

    // Reminder: one more auto-open, a few minutes after the first was closed.
    setInterval(function () {
      if (autoCount() !== 1 || autoOpenedThisPage && isOpen) return;
      if (sGet(CARTED_KEY)) return;
      var dismissed = parseInt(sGet(DISMISSED_KEY), 10);
      if (isNaN(dismissed) || Date.now() - dismissed < REMIND_MS) return;
      if (Date.now() - lastActivity > ACTIVE_WINDOW_MS) return;
      autoOpen('reminder');
    }, 5000);

    // Anyone with something in their bag doesn't get the reminder.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.item_count > 0) markCarted(); })
      .catch(function () { /* no-op */ });
    document.addEventListener('submit', function (e) {
      var action = (e.target && e.target.getAttribute('action')) || '';
      if (action.indexOf('/cart') !== -1) markCarted();
    }, true);

    // Never cover a buy button someone just tapped.
    var checkoutTriggers = document.querySelectorAll('#pdpForm, #pdpCta, #stickyMobile, #purchaseCta, [data-plan-select], [data-pdp-quick-buy]');
    checkoutTriggers.forEach(function (el) {
      el.addEventListener('pointerdown', function () {
        if (el.matches('#pdpCta, [data-pdp-quick-buy], #purchaseCta')) markCarted();
        if (isOpen) closePopup();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupTriggers);
  } else {
    setupTriggers();
  }
})();
